import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StockTransferService {

  private baseUrl = `${environment.Server_URL}/stock-transfer`;

  constructor(private http: HttpClient) { }

  // 🟢 Create bulk transfer (أكتر من stock في نفس العملية)
  createTransfer(payload: {
    from_warehouse_id: number;
    to_warehouse_id: number;
    notes?: string;
    items: {
      stock_id: number;
      quantity: number;
    }[];
  }): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  // 🟢 Get transfer history (pagination)
  getHistory(
    page: number = 1,
    perPage: number = 10,
    warehouseId?: any
  ): Observable<any> {

    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    if (warehouseId) {
      params = params.set('warehouse_id', warehouseId);
    }

    return this.http.get(`${this.baseUrl}-history`, { params });
  }


  // 🟢 Get single transfer details
  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
}
